import React, {Component} from 'react';
import {Line, Chart} from 'react-chartjs-2';

const skipped = (ctx, value) => ctx.p0.skip || ctx.p1.skip ? value : undefined;
// const down = (ctx, value) => ctx.p0.parsed.y > ctx.p1.parsed.y ? value : undefined;
// Chart.defaults.scale.ticks.display = false;

const options = {
	reponsive: true,
	maintainAspectRatio: false,
	interaction: {
		mode: 'index',
		intersect: false,
	},
	legend: {
		display: false
	},
	plugins: {
		datalabels : {
			display: false
		},
		legend: {
			display: false
		},
		tooltip: {
			enabled: false,
			// 커스텀 툴팁 생성(개발연동시 클래스명 확인)
			external: function (context) {
				// Tooltip Element
				var tooltipEl = document.getElementById('LineChartToolTip');

				// Hide if no tooltip
				var tooltipModel = context.tooltip
				if (tooltipModel.opacity === 0) {
					tooltipEl.style.opacity = 0;
					return;
				}

				// Set caret Position
				tooltipEl.classList.remove('above', 'below', 'no-transform');
				if (tooltipModel.yAlign) {
					tooltipEl.classList.add(tooltipModel.yAlign);
				} else {
					tooltipEl.classList.add('no-transform');
				}

				function getBody(bodyItem) {
					return bodyItem.lines;
				}

				// Set Text
				if (tooltipModel.body) {
					var _html = '';

					_html += '<div class="tooltip-inner">';
					var bodyLines = tooltipModel.body.map(getBody);
					bodyLines.forEach(function (body, i) {
						var _body = String(body);
						var _title = _body.substring(0, _body.indexOf(':'));
						var _data = _body.substring(_body.indexOf(':') + 1, _body.length);
						var colors = tooltipModel.labelColors[i];
						_html += '<div class="tooltip-data-cell">';
						_html += '<div class="tooltip-bg" style="background-color:' + colors.borderColor + ';"></div>';
						_html += '<div class="tooltip-subject">' + _title + '</div>';
						_html += '<div class="tooltip-value">' + _data + '</div>';
						_html += '</div>';
					});
					_html += '</div>';

					tooltipEl.innerHTML = _html;
				}

				// `this` will be the overall tooltip
				var position = context.chart.canvas.getBoundingClientRect();

				//console.log(tooltipModel.caretX);

				// Display, position, and set styles for font
				tooltipEl.style.opacity = 1;
				tooltipEl.style.position = 'absolute';

				if (tooltipModel.caretX >= (position.width / 2)) {
					tooltipEl.style.left = ((position.left + window.pageXOffset + tooltipModel.caretX) - tooltipEl.getBoundingClientRect().width) + 'px';
					tooltipEl.classList.add('right');
					tooltipEl.classList.remove('left');
				} else {
					tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
					tooltipEl.classList.add('left');
					tooltipEl.classList.remove('right');
				}

				tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
				tooltipEl.style.pointerEvents = 'none';

			}
		}
	},
	scales: {
		yAxes: [{
			ticks: {
				display: false
			}
		}],
		x: {
			scaleLabel: {
				display: false
			},
			grid: {
				display: true,
				tickLength: 10,
				color: 'rgba(0,0,0,0.1)',
				drawBorder: false
			},
			ticks: {
				font: {
					family: 'sans-serif',
					size: 14,
					lineHeight: 1.6
				},
				color: 'rgba(0,0,0,0.7)'
			}
		},
		y: {
			// beginAtZero: true,
			// suggestedMax: 69,
			scaleLabel: {
				display: false
			},
			grid: {
				display: false,
				drawBorder: false
			},
			ticks: {
				display: false
			}
		}
	},
	layout: {
		padding: {
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}
	},
	title: {
		display: false
	}
};

class LineChart extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: {
				labels: [],
				datasets: []
			}
		}
	}

	componentDidMount() {
		const records = this.props.records;

		let temp = this.state.data;
		Object.keys(records).map((item, key) => {
			if (item === 'labels') {
				temp.labels = records[item];
			} else {
				const color = records[item].color ? records[item].color : "rgb(223,142,96)";
				temp.datasets.push({
					label: item,
					borderWidth: 4,
					borderColor: color,
					pointBorderColor: color,
					pointBackgroundColor: 'rgb(255, 255, 255)',
					pointBorderWidth: 2,
					pointRadius: 4,
					pointHoverRadius: 4,
					pointHoverBackgroundColor: '#fff',
					tension: 0.4,
					segment: {
						borderDash: ctx => skipped(ctx, [6, 6])
					},
					data: records[item].data
				});
			}
		});

		this.setState({data: temp})
	}

	render() {
		return (
			<Line data={this.state.data} options={options}/>
		)
	}
}

export default LineChart;